module.exports = __webpack_public_path__ + "img/Control Panel-amico (1).6c091f82.png";